import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputErrorMessage from './InputErrorMessage';
import { uniqueIdForComponent, INPUT_SIZES } from '../../../util';
import Label from './Label';
import DropdownOption from './DropdownOption';

var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.state = {
      value: _this.props.value || '',
      inputStatus: _this.props.status,
      errorMessage: _this.props.errorMessage
    };
    _this.id = _this.props.id || uniqueIdForComponent(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var errorMessage = _ref.errorMessage,
          status = _ref.status,
          value = _ref.value;
      this.setState({
        errorMessage: errorMessage,
        inputStatus: status,
        value: value || ''
      });
    }
    /**
     * Update the state when user selects a new option
     * @param {event} event The async event
     */

  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        value: event.target.value
      });
      this.props.onChange(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2;

      var emptyPlaceholder = null;

      if (this.props.placeholder) {
        emptyPlaceholder = React.createElement(DropdownOption, {
          value: "",
          disabled: true
        }, this.props.placeholder);
      }

      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          label = _this$props.label,
          labelControl = _this$props.labelControl,
          ariaLabel = _this$props.ariaLabel,
          hint = _this$props.hint,
          optional = _this$props.optional,
          optionalIndicatorText = _this$props.optionalIndicatorText,
          required = _this$props.required,
          requiredIndicatorText = _this$props.requiredIndicatorText,
          leftAddon = _this$props.leftAddon,
          rightAddon = _this$props.rightAddon,
          children = _this$props.children,
          value = _this$props.value,
          status = _this$props.status,
          errorMessage = _this$props.errorMessage,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          size = _this$props.size,
          sizeFixed = _this$props.sizeFixed,
          isFieldSetItem = _this$props.isFieldSetItem,
          isInlineFieldSetItem = _this$props.isInlineFieldSetItem,
          helpMessage = _this$props.helpMessage,
          helpLabel = _this$props.helpLabel,
          helpAriaLabel = _this$props.helpAriaLabel,
          autoComplete = _this$props.autoComplete,
          otherProps = _objectWithoutProperties(_this$props, ["id", "className", "label", "labelControl", "ariaLabel", "hint", "optional", "optionalIndicatorText", "required", "requiredIndicatorText", "leftAddon", "rightAddon", "children", "value", "status", "errorMessage", "placeholder", "onChange", "size", "sizeFixed", "isFieldSetItem", "isInlineFieldSetItem", "helpMessage", "helpLabel", "helpAriaLabel", "autoComplete"]);

      var formItemStyle = classnames(className, 'wds-c-form-item', _defineProperty({
        'wds-c-input-error': this.state.inputStatus === 'error',
        'wds-c-fieldset__form-item': isFieldSetItem || isInlineFieldSetItem,
        'wds-c-fieldset-inputs--inline__form-item': isInlineFieldSetItem
      }, "wds-c-fieldset-inputs--inline__form-item--".concat(size), size && isInlineFieldSetItem));
      var dropdownStyle = classnames('wds-c-select', (_classnames2 = {}, _defineProperty(_classnames2, "wds-c-select--".concat(size), size && !isInlineFieldSetItem), _defineProperty(_classnames2, 'wds-c-fieldset__form-item', isFieldSetItem || isInlineFieldSetItem), _defineProperty(_classnames2, 'wds-c-select--size-fixed', sizeFixed), _classnames2));
      var labelId = label && "".concat(this.id, "-label");
      var errorId = "".concat(this.id, "-error");
      var labelledBy = this.state.inputStatus === 'error' && this.state.errorMessage ? errorId : labelId;
      var selectControl = React.createElement("select", _extends({
        name: id,
        id: this.id
      }, hint && {
        'aria-describedby': "".concat(this.id, "-hint")
      }, labelledBy && {
        'aria-labelledby': labelledBy
      }, {
        value: this.state.value,
        onBlur: this.handleChange,
        onChange: this.handleChange,
        className: dropdownStyle
      }, ariaLabel && {
        'aria-label': ariaLabel
      }, autoComplete && {
        'autoComplete': autoComplete
      }, otherProps), emptyPlaceholder, children); // Don't generate Label if no label is specified (will generate
      // console warning because Label requires children)

      var labelElement = label && React.createElement(Label, {
        htmlFor: this.id,
        optional: optional,
        optionalIndicatorText: optionalIndicatorText,
        required: required,
        requiredIndicatorText: requiredIndicatorText,
        hint: hint,
        helpMessage: helpMessage,
        helpLabel: helpLabel,
        helpAriaLabel: helpAriaLabel
      }, label);
      var isLeftAddon = leftAddon !== '' && leftAddon !== undefined;
      var isRightAddon = rightAddon !== '' && rightAddon !== undefined;

      if (!label && !ariaLabel) {
        console.warn('Either label or ariaLabel property is mandatory for Dropdown Component.');
      }

      return React.createElement("div", {
        className: formItemStyle
      }, (label || labelControl) && React.createElement(React.Fragment, null, label && labelElement, labelControl && labelControl), isLeftAddon || isRightAddon ? React.createElement("div", {
        className: "wds-c-form-item__input-group"
      }, isLeftAddon && React.createElement("span", {
        className: "wds-c-input-group-addon"
      }, leftAddon), selectControl, isRightAddon && React.createElement("span", {
        className: "wds-c-input-group-addon"
      }, rightAddon)) : selectControl, this.state.inputStatus === 'error' && this.state.errorMessage && this.state.errorMessage.length > 0 && React.createElement(InputErrorMessage, {
        id: errorId
      }, this.state.errorMessage));
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.propTypes = {
  /** Id for the dropdown */
  id: PropTypes.string,

  /** Additional styles */
  className: PropTypes.string,

  /** label for dropdown component */
  label: PropTypes.node,

  /**  control element for the dropdown field label */
  labelControl: PropTypes.node,

  /** Used to provide screen reader text */
  ariaLabel: PropTypes.string,

  /** hint text */
  hint: PropTypes.node,

  /* placeholder text for no selection.
  if the property is not set, a placeholder is not displayed */
  placeholder: PropTypes.string,

  /** children of dropdown */
  children: PropTypes.node.isRequired,

  /** specifies if the dropdown is required */
  required: PropTypes.bool,

  /** error message to display when there is an input error */
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /** selected value */
  value: PropTypes.string,

  /** function to perform on change */
  onChange: PropTypes.func,

  /** sets the status, to either default or error. */
  status: PropTypes.oneOf(['error']),

  /**  bool value to indicate if the field is optional field */
  optional: PropTypes.bool,

  /**  text to indicate a field is optional */
  optionalIndicatorText: PropTypes.string,

  /** text to display when the dropdown is required */
  requiredIndicatorText: PropTypes.string,

  /** left addon for input field */
  leftAddon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** right addon for input field */
  rightAddon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** size of the input */
  size: PropTypes.oneOf(INPUT_SIZES),

  /** sized input is will not adapt to available space */
  sizeFixed: PropTypes.bool,

  /** set automatically by FieldSet to all containing input elements that can be sized. Not recommended to be used directly  */
  isFieldSetItem: PropTypes.bool,

  /** set automatically by inline FieldSet to all containing input elements that can be sized. Not recommended to be used directly  */
  isInlineFieldSetItem: PropTypes.bool,

  /** Node to be used as the help message */
  helpMessage: PropTypes.node,

  /** help toggle button label */
  helpLabel: PropTypes.string,

  /** used by screen readers to describe the input help toggle button */
  helpAriaLabel: PropTypes.string,

  /** provides automated assistance in filling out form field values.
   * Supports the full list of possible parameters
   */
  autoComplete: PropTypes.string
};
Dropdown.defaultProps = {
  className: undefined,
  optional: false,
  optionalIndicatorText: undefined,
  required: false,
  errorMessage: undefined,
  value: undefined,
  id: undefined,
  onChange: function onChange() {},
  status: null,
  requiredIndicatorText: undefined,
  leftAddon: undefined,
  rightAddon: undefined,
  label: undefined,
  labelControl: undefined,
  ariaLabel: undefined,
  hint: undefined,
  placeholder: undefined,
  size: undefined,
  sizeFixed: false,
  isFieldSetItem: false,
  isInlineFieldSetItem: false,
  helpMessage: undefined,
  helpLabel: undefined,
  helpAriaLabel: undefined,
  autoComplete: undefined
};
export default Dropdown;